
import { useCognitoAdmin } from "@/services";
import { defineComponent } from "vue";
export default defineComponent({
  name: "PermissionChangedModal",
  methods: {
    async close() {
      await useCognitoAdmin().logout();
      this.$router.push({ path: "/login", replace: true });
    },
  },
});
